module.exports = __webpack_public_path__ + "static/cky-03a22d663156e5c6233d9f09aa7c08ef.png";